<app-table-header
  (reload)="load()"
  [loading]="loading"
  [withExportOption]="false"
></app-table-header>

@if (storesArr$ | async; as storesArr) {
  <nz-table appColumnLayout id="article-variants-stores-stocks-table"
    #tableRef
    style="width: 100%"
    [nzData]="variants"
    [nzLoading]="loading"
    [nzShowPagination]="false"
    [nzScroll]="{ x: (575 + storesArr.length * 180) + 'px' }"
    >
    <thead>
      <tr>
        <th nzColumnKey="id" nzWidth="75px">#ID</th>
        <th nzColumnKey="name" nzWidth="220px">Name</th>
        <th nzColumnKey="orderNumber" nzWidth="140px">Bestellnummer</th>
        <th nzColumnKey="ean" nzWidth="140px">EAN</th>
        @for (store of storesArr; track store) {
          <th
            [attr.nzColumnKey]="store.id"
            nzWidth="180px"
            [attr.title]="store.value"
          >{{store.value}}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (variant of variants; track variant) {
        <tr>
          <td>{{variant.id}}</td>
          <td>{{variant.name || variant.articleName }}</td>
          <td class="cell-nowrap">{{variant.orderNumber}}</td>
          <td class="cell-nowrap">{{variant.ean}}</td>
          @for (store of storesArr; track store; let i = $index) {
            <td class="cell-nowrap">
              {{ variant.stocks | stockByStore:store }}
            </td>
          }
        </tr>
      }
    </tbody>
  </nz-table>
}

<app-store-stocks-corrections-modal #correctionsModalComponent></app-store-stocks-corrections-modal>
